import { ArrayInput, FormDataConsumer, SimpleFormIterator } from "react-admin";
import Inputs from "./Inputs";

export default function FactoryDebtPayItemForm() {
  return (
    <ArrayInput
      source="factory_debt_payment_items"
      defaultValue={[
        {
          purchase_order_id: "",
          transaction_date: "", // disabled
          due_date: "", // disabled
          debt: "", // disabled
          amount: "",
        },
      ]}
    >
      <SimpleFormIterator
        disableReordering
        getItemLabel={(index) => `#${index + 1}`}
        fullWidth={true}
        sx={{
          "& .RaSimpleFormIterator-line": {
            border: "none",
          },
        }}
      >
        <FormDataConsumer>{Inputs}</FormDataConsumer>
      </SimpleFormIterator>
    </ArrayInput>
  );
}
